import { render, staticRenderFns } from "./announcementOfManagement.vue?vue&type=template&id=edd55f9c&scoped=true"
import script from "./announcementOfManagement.vue?vue&type=script&lang=js"
export * from "./announcementOfManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd55f9c",
  null
  
)

export default component.exports